export enum AdesaoStatus {
  Pendente = 'Pendente',
  Solicitado = 'Solicitado',
  Concluido = 'Concluído',
  Cancelada = 'Cancelado',
}
